import { FC } from 'react'
import { GRAY_600 } from 'constants/styling/theme'
import ReactLoading from 'react-loading'
import Stack from '@mui/material/Stack'

/**
 * Centered loading spinner for assignment detail drawer renderers.
 * @example
 * if (isLoading) return <RendererLoadingState />
 */
export const RendererLoadingState: FC = () => (
  <Stack alignItems="center" justifyContent="center" padding="1rem 0">
    <ReactLoading type="spin" color={GRAY_600} width={24} height={24} />
  </Stack>
)
